import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import HeadTitle from "../../Common/HeadTitle/HeadTitle";
import "./About.css";
import AboutCard from "./AboutCard";

const About = () => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeadTitle />

      <section className="about top">
        <div className="container">
          <AboutCard />
        </div>
      </section>

      <section className="features top">
        <div className="container aboutCard flex_space">
          <div className="row row1">
            <h1>
              {t("our")} <span>{t("features")}</span>
            </h1>
            <div className="cuisine-text">
              <p className="cuisine-part">
                {t("cuisinePart1")}
              </p>
              <p className="cuisine-part">
                {t("cuisinePart2")}
              </p>
              <p className="cuisine-part">
                {t("cuisinePart3")}
              </p>
              <p className="cuisine-part">
                {t("cuisinePart4")}
              </p>
              <p className="cuisine-part">
                {t("cuisinePart5")}
              </p>
            </div>
          </div>
          <div className="row image">
            <img src="/images/newimages/1.jpg" alt="Restaurant ambiance" />
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
